import * as React from "react";
const SvgFiRrGolfBall = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-golf-ball_svg__a)">
      <path
        fill="#062147"
        d="M15 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m2-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m2-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m2 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.056 9.086a4.96 4.96 0 0 1-1.41 2.792L13 21.414V23a1 1 0 1 1-2 0v-1.586l-1.535-1.536a4.96 4.96 0 0 1-1.41-2.792 9 9 0 1 1 7.89 0m-2.824 1.378c.4-.403.677-.91.8-1.464h-3.85c.124.553.402 1.06.8 1.464L12 19.586zM19 9a7 7 0 1 0-10.594 6.005Q8.45 15 8.5 15h7q.047-.001.094.005A6.97 6.97 0 0 0 19 9"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-golf-ball_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGolfBall;
